import { render } from "./AssessmentsView.vue?vue&type=template&id=0e7eca1e"
import script from "./AssessmentsView.vue?vue&type=script&lang=js"
export * from "./AssessmentsView.vue?vue&type=script&lang=js"

import "./AssessmentsView.vue?vue&type=style&index=0&id=0e7eca1e&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTable,QTr,QTd,QChip,QTooltip,QInput,QIcon});
